// Server-side pages (POST /v1/donors/batch-get with page/page_size):
// page_size is 20 | 50 | 100 on the API, so no "all" option.
export const DONOR_LIST_PAGINATION = {
    pageSize: 20,
    pageSizes: [20, 50, 100],
    allPagesSize: false,
    startPage: 1,
};

// Server-side pages (GET /v1/bloodbanks/{id}/messages?page=&page_size=):
// page_size is validated by the API as 25 | 50 | 100, so no "all" option.
export const PUSH_MESSAGES_PAGINATION = {
    pageSize: 25,
    pageSizes: [25, 50, 100],
    allPagesSize: false,
    startPage: 1,
};